module.exports = __webpack_public_path__ + "img/wx-video-qrcode.d2f0aeda.jpg";